import { PERMISSIONS } from "permissions";
import React from "react";
import { useAppSelector } from "redux/hooks";
import CommonInternalDashboard from "./CommonInternalDashboard";
import FinanceDashboard from "./FinanceDashboard";
import InsurerStatsDashboard from "./InsurerStatsDashboard";
import OriginationMember from "./OriginationMember";
import RiskManagementDashboard from "./RiskManagementDashboard";
import { useGetCurrentUserQuery } from "api/api-users-v2";
import InvestorDashboard from "investor/pages/InvestorDashboard";
import MasterInvestorDashboard from "investor/pages/MasterInvestorDashboard";

const DepartmentScreen: React.FC = () => {
  const USER_PERMISSION = useAppSelector(
    (state) => state.appState.user_permission
  );

  const { data: curr_user } = useGetCurrentUserQuery();
  
  // Check for master investor permission first
  if (USER_PERMISSION?.includes("show_master_investor") && !USER_PERMISSION?.includes("show_investor")) {
    return <MasterInvestorDashboard />;
  } 
  // Check for investor permission
  else if (USER_PERMISSION?.includes("show_investor") && !USER_PERMISSION?.includes("show_master_investor")) {
    return <InvestorDashboard />;
  }
  // Check for other roles
  else if (curr_user?.user_role === "Sales_Partner") {
    return <OriginationMember />;
  } else if (USER_PERMISSION?.includes(PERMISSIONS.restricted_view_stats)) {
    return <OriginationMember />;
  } else if (USER_PERMISSION?.includes(PERMISSIONS.show_insurer_stats)) {
    return <InsurerStatsDashboard />;
  } else if (USER_PERMISSION?.includes(PERMISSIONS.show_risk_management)) {
    return <RiskManagementDashboard />;
  } else if (USER_PERMISSION?.includes(PERMISSIONS.termsheet_financing)) {
    return <FinanceDashboard />;
  } else {
    return <CommonInternalDashboard />;
  }
};

export default DepartmentScreen;
